import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { TeachersPerformanceReportFilterForm } from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { DataWithPagination } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { TeachersPerformanceReport } from '../model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class TeachersPerformanceReportApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getTeachersPerformanceReport(
    filter: TeachersPerformanceReportFilterForm
  ): Observable<DataWithPagination<TeachersPerformanceReport[]>> {
    return this.baseAPI.post(Constants.GET_TEACHERS_PERFORMANCE_REPORT_API_URL, filter).pipe(
      map((res) => {
        const data: DataWithPagination<TeachersPerformanceReport[]> = {
          data: this.mapper.fromListJson(TeachersPerformanceReport, res.data),
          count: res.count,
        };
        return data;
      })
    );
  }
}
